import React, { useMemo } from "react";
import { Drawer, Card, Divider, Table, Tag, Typography } from "antd";
import moment from "moment";
import ConversationPanel from "./ConversationPanel";
import { CONSTANTS } from "../../../../../utils/constants";

const { Text } = Typography;

const money = (v) => {
	const n = Number(v ?? 0);
	return `$${n.toFixed(2)}`;
};

export default function OrderConversationDrawer({
	open,
	onClose,
	conversationId,
	order,
}) {
	const items = order?.items ?? [];

	const itemsColumns = useMemo(
		() => [
			{
				title: "Producto",
				dataIndex: "productTitle",
				render: (v, r) => (
					<div style={{ display: "flex", flexDirection: "column" }}>
						<Text strong>{v}</Text>
						<Text type="secondary" style={{ fontSize: 12 }}>
							EAN: {r.productEan13 || "-"}
						</Text>
					</div>
				),
			},
			{
				title: "Cant.",
				dataIndex: "quantity",
				width: 70,
				align: "right",
			},
			{
				title: "Precio",
				dataIndex: "price",
				width: 110,
				align: "right",
				render: (v) => money(v),
			},
			{
				title: "Oferta",
				dataIndex: "offerPrice",
				width: 110,
				align: "right",
				render: (v) => money(v),
			},
			{
				title: "Desc.",
				dataIndex: "discount",
				width: 80,
				align: "right",
				render: (v) => `${Number(v ?? 0).toFixed(2)}%`,
			},
		],
		[]
	);

	return (
		<Drawer
			open={open}
			onClose={onClose}
			width="92vw"
			title={
				<div style={{ display: "flex", alignItems: "center", gap: 10 }}>
					<Text strong>TRF #{order?.orderNumId ?? "-"}</Text>
					{order?.state && (
						<Tag
							color={
								CONSTANTS.AGENT_ORDERS[order.state?.toLowerCase()]?.color ||
								"blue"
							}
							style={{ margin: 0 }}
						>
							{CONSTANTS.AGENT_ORDERS[order.state?.toLowerCase()]?.label ||
								order.state}
						</Tag>
					)}
				</div>
			}
			bodyStyle={{ padding: 12 }}
			destroyOnClose
		>
			<div
				style={{
					display: "grid",
					gridTemplateColumns: "1fr 1fr",
					gap: 12,
					height: "calc(100vh - 160px)",
				}}
			>
				<Card
					title="Conversación"
					style={{ height: "100%" }}
					bodyStyle={{
						height: "calc(90vh - 100px)",
						overflow: "auto",
						padding: 12,
					}}
				>
					<ConversationPanel open={open} conversationId={conversationId} />
				</Card>

				<Card
					title="Detalle de orden"
					style={{ height: "100%" }}
					bodyStyle={{
						height: "calc(90vh - 100px)",
						overflow: "auto",
						padding: 12,
					}}
				>
					<Card
						size="small"
						style={{ marginBottom: 12 }}
						bodyStyle={{ padding: 12 }}
					>
						<div style={{ display: "flex", justifyContent: "space-between" }}>
							<div>
								<Text type="secondary">Punto de venta</Text>
								<div>
									<Text strong>{order?.pointOfSaleName || "-"}</Text>
								</div>
								<Text type="secondary" style={{ fontSize: 12 }}>
									CUIT: {order?.pointOfSaleCuit || "-"}
								</Text>
							</div>
							<div>
								<Text type="secondary">Droguería</Text>
								<div>
									<Text strong>
										{order?.distributorName || "-"} (
										{order?.distributorCode || "-"})
									</Text>
								</div>
							</div>
							<div style={{ textAlign: "right" }}>
								<Text type="secondary">Laboratorio</Text>
								<div>
									<Text strong>{order?.laboratoryName || "-"}</Text>
								</div>
							</div>
						</div>
						<div
							style={{
								display: "flex",
								justifyContent: "space-between",
								marginTop: 12,
							}}
						>
							<div>
								<Text type="secondary">Fecha</Text>
								<div>
									<Text strong>
										{order?.created
											? moment(order.created).format("DD-MM-YYYY HH:mm")
											: "-"}
									</Text>
								</div>
							</div>

							<div style={{ textAlign: "right" }}>
								<Text type="secondary">Totales</Text>
								<div>
									<Text strong>Subtotal: {money(order?.subTotal)}</Text>
								</div>
								<div>
									<Text strong>Total: {money(order?.total)}</Text>
								</div>
							</div>
						</div>
					</Card>

					<Divider />

					<Text strong>Items ({order?.totalItems ?? items.length})</Text>

					<Table
						size="small"
						rowKey="id"
						columns={itemsColumns}
						dataSource={items}
						pagination={false}
						style={{ marginTop: 10 }}
					/>
				</Card>
			</div>
		</Drawer>
	);
}
